module.exports = __webpack_public_path__ + "img/main_media_slide3.ec53cedf.jpg";